import React, { useState } from "react";
import styled from "@emotion/styled";

import FormHelper from "../../utils/FormHelper";
import Form from "../LoginBox/Form";
import FormBox from "../LoginBox/FormBox";

const ForgetPasswordBox = (props) => {
  const { navigate, location, dataHelper, userHelper, message, config } = props;

  const [loading, setLoading] = useState(0);
  
  const values = {
    Username: location?.state?.username,
  };

  const inputs = Forgotpasswordform(config, values);

  const forgotPassword = async (formData) => {
    let username = formData["Username"];

    username = username.toLowerCase();

    let result = await userHelper.recoverPassword(username);

    if (result.success) {
      switch (result.code) {
        case "user-exists":
        // case "user-needs-password-definition":
        //   return {
        //     success: true,
        //     redirect: [
        //       routes.accessCode.path,
        //       {
        //         UserFirebaseId: result.UserFirebaseId,
        //         forcePasswordDefinition: true,
        //       },
        //     ],
        //   };
        //   break;
        case "user-does-not-exist": // silencioso
          // inputs.Username.focusError(config.strings.form.message.USER_NOT_FOUND);
          break;
        default:
          return {
            success: true,
            redirect: [
              "/redefinir-senha/sucesso",
              { state: { email: username } },
            ],
          };
      }
    } else {
      if (result?.error?.code) {
        switch (result?.error?.code) {
          case "auth/user-not-found":
            inputs.Username.focusError("Usuário não encontrado.");
            break;
          default:
            message.add({
              type: "error",
              message:
                "Não foi possível processar sua requisição. Por favor, tente novamente mais tarde.",
            });
        }
      } else if (result?.message) {
        message.add({ type: "error", message: result.message });
      } else {
        message.add({
          type: "error",
          message:
            "Não foi possível processar sua requisição. Por favor, tente novamente mais tarde.",
        });
      }
    }
  };

  return (
    <Container>
      <FormBox
        {...props}
        config={config}
        title="Redefinir Senha"
        description="Digite abaixo o seu e-mail cadastrado:"
        inside={
          <Form
            navigate={navigate}
            location={location}
            dataHelper={dataHelper}
            config={config}
            inputs={inputs}
            handleSend={forgotPassword}
            loading={loading}
            setLoading={setLoading}
            sendLabel="Enviar"
          />
        }
        withPadding
      />
    </Container>
  );
};

export default ForgetPasswordBox;

/* form */

const Forgotpasswordform = (props, startValues) => {
  return {
    Username: FormHelper.useFormInput({
      label: "E-mail",
      type: "text",
      validations: [
        {
          type: "required",
          errorMessage: "Digite um E-mail",
        },
      ],
      inputOptions: {
        spellCheck: false,
      },
      mask: "username",
      maskOptions: ["text", "cpf"],
      startValue: startValues?.Username,
    }),
  };
};

const Container = styled.div`
  display: flex;
  flex-direction: column;
  gap: 48px;
  align-items: center;
  margin-top: 42px;
  height: 100vh;
`;
